/**
 * Format an orderbook price to the grouping's decimal count.
 * Pads to `decimals` so values like "0.911" render as "0.9110" (the API strips
 * trailing zeros). For whole-number groupings (`decimals <= 0`) the value is
 * rounded to an integer. Non-finite input is returned as-is (defensive against
 * malformed API px strings).
 */
export function formatOrderbookPrice(
	value: string | number,
	decimals: number,
): string {
	const num = typeof value === "number" ? value : Number(value);
	if (!Number.isFinite(num)) return String(value);
	// ponytail: decimals<=0 rounds to integer (matches the previous number-input
	// path); integer-grouped books have integer px already, so output is unchanged.
	return decimals > 0 ? num.toFixed(decimals) : Math.round(num).toString();
}
